import React, { Component } from 'react'
import styled from 'styled-components'
import Typed from 'typed.js';

const TypedJs = styled.div`
  line-height: 0.6em;
  color: white;
  text-align: right;

  > span {
    color: white
  };

  strong {
    color: #97E08B
  }
`

class TypedJsElement extends Component {
  componentDidMount() {
    const { strings } = this.props;
    // You can pass other options here, such as typing speed, back speed, etc.
    const options = {
    	strings: strings,
      typeSpeed: 50,
      loop: true,
      fadeOut: true,
      fadeOutDelay: 3000,
      showCursor: false,
      fadeOutClass: 'typed-fade-out',
    };
    // this.el refers to the <span> in the render() method
    this.typed = new Typed(this.el, options);
  }

  render() {
    const { fontSize } = this.props;

    return(
      <TypedJs style={{fontSize: fontSize}}>
        <span
          style={{ whiteSpace: 'pre' }}
          ref={(el) => { this.el = el; }}
        />
      </TypedJs>
    )
  }
}

export default TypedJsElement